export default __webpack_public_path__ + "static/media/023-corn.2738d33c.svg";